export default "__VITE_ASSET__WJfSX4VF__"